// Must be the same as `src/baserow/contrib/database/views/models.py`.
export const DEFAULT_FORM_VIEW_FIELD_COMPONENT_KEY = 'default'

// Must be the same as `src/baserow/contrib/database/views/models.py`.
export const DEFAULT_SORT_TYPE_KEY = 'default'

// Must be the same as `MAX_GROUP_BY_LEVELS` in
// `src/baserow/contrib/database/views/models.py`.
export const MAX_GROUP_BY_LEVELS = 3

export const GRID_VIEW_SIZE_TO_ROW_HEIGHT_MAPPING = {
  small: 33,
  medium: 55,
  large: 99,
  xlarge: 143,
}

export const GRID_VIEW_MIN_FIELD_WIDTH = 78

export const GRID_VIEW_MULTI_SELECT_AREA = 'area'
export const GRID_VIEW_MULTI_SELECT_CHECKBOX = 'checkbox'

export const LINKED_ITEMS_DEFAULT_LOAD_COUNT = 20
export const LINKED_ITEMS_LOAD_ALL = -1

// Must be the same as `UNIQUE_CONSTRAINT_NAME` in
// `src/baserow/contrib/database/fields/constants.py`.
export const UNIQUE_CONSTRAINT_NAME = 'unique'

// The field types the uniqueness rule can be enforced on. Mirrors the compatible
// field types of the constraints in `fields/field_constraints.py`.
export const UNIQUENESS_FIELD_TYPES = [
  'text',
  'long_text',
  'url',
  'email',
  'number',
  'date',
  'duration',
  'rating',
  'single_select',
]

// The field types whose values have a case and whitespace to fold at all, and
// therefore offer the two comparison options.
export const UNIQUENESS_COMPARISON_FIELD_TYPES = [
  'text',
  'long_text',
  'url',
  'email',
]

export const FIELD_CONSTRAINT_ERROR_CODES = [
  'ERROR_FIELD_CONSTRAINT',
  'ERROR_INVALID_FIELD_CONSTRAINT',
  'ERROR_FIELD_CONSTRAINT_DOES_NOT_SUPPORT_DEFAULT_VALUE',
  'ERROR_FIELD_TYPE_CHANGE_BLOCKED_BY_CONSTRAINT',
]

// Axis cardinality caps of the pivot view. Mirrors PIVOT_MAX_ROWS /
// PIVOT_MAX_COLUMNS in `backend/.../views/pivot_handler.py`, which enforces
// them; kept here so the configuration UI can name the limit up front instead
// of only reporting it after a failed fetch.
export const PIVOT_MAX_ROWS = 500
export const PIVOT_MAX_COLUMNS = 50
